import { Box, Flex } from "@chakra-ui/layout";
import { Text } from "@chakra-ui/react";
import { Col, Row } from "antd";
import {
  GrupoDescontoForm,
  FormaAplicacaoValorEnum,
} from "core/features/grupo-desconto/typings";
import colors from "core/resources/theme/colors";
import { Control, UseFormSetValue } from "react-hook-form";
import { BiBuildingHouse } from "react-icons/bi";
import { FaUsers } from "react-icons/fa";
import IconShadowSelectableButton from "ui/components/Button/IconShadowSelectableButton";
import Field from "ui/components/Input/Field";
import InputMoney from "ui/components/Input/InputMoney";
import SelectBaseAntd from "ui/components/Input/SelectBaseAntd";
import {
  getAplicarDescontoDiaOptions,
  getFormaDescontoOptions,
} from "./util/helper";
import SelectDestino from "ui/components/SelectDestinos/SelectDestino";
import { useCurrentTenant } from "features/auth/tenant.store";
import { TipoEntidadeEnum } from "core/resources/enums/conta";

interface FormGrupoDescontoProps {
  control: Control<GrupoDescontoForm, object>;
  setValue: UseFormSetValue<GrupoDescontoForm>;
  form: GrupoDescontoForm;
}

function FormGrupoDesconto({
  control,
  setValue,
  form,
}: FormGrupoDescontoProps) {
  const { tenant } = useCurrentTenant();

  return (
    <>
      <Title text="Configurar desconto" />

      <Box as={Row}>
        <Field
          control={control}
          name="personalizado"
          rules={{
            required: true,
          }}
          render={({ field }) => (
            <Flex flexDir="column">
              <Box as={Row} gutter={30} mb={8} px={20}>
                <Box as={Col} sm={12}>
                  <IconShadowSelectableButton
                    selected={field.value === "1"}
                    value={"1"}
                    onChange={field.onChange}
                    Icon={FaUsers}
                    color={colors.cyan}
                    iconSize={16}
                    text="Personalizar"
                  />
                </Box>

                <Box as={Col} sm={12}>
                  <IconShadowSelectableButton
                    selected={field.value === "0"}
                    value={"0"}
                    onChange={field.onChange}
                    Icon={BiBuildingHouse}
                    color={colors.primary}
                    iconSize={16}
                    text="Pagamento antes ou até o vencimento"
                  />
                </Box>
              </Box>
            </Flex>
          )}
        />
      </Box>

      {form.personalizado === "0" ? (
        <Box as={Row} gutter={32} mb={8}>
          <Box as={Col} xs={12}>
            <Field
              label="Aplicar desconto"
              control={control}
              name="antesVencimento"
              rules={{
                required: true,
              }}
              render={({ field, isInvalid }) => (
                <SelectBaseAntd
                  size="large"
                  onChange={field.onChange}
                  isInvalid={isInvalid}
                  value={field.value}
                  options={getAplicarDescontoDiaOptions()}
                />
              )}
            />
          </Box>

          {form.antesVencimento === "1" ? (
            <Box as={Col} xs={12}>
              <Field
                shouldUnregister
                label="Quantos dias antes do vencimento?"
                control={control}
                name="diasAntesVencimento"
                rules={{
                  required: true,
                }}
                render={({ field }) => (
                  <InputMoney
                    placeholder="0"
                    decimalScale={0}
                    decimalsLimit={0}
                    allowDecimals={false}
                    {...field}
                  />
                )}
              />
            </Box>
          ) : null}
        </Box>
      ) : null}

      <Title text="Quem irá receber o desconto?" />

      <Box as={Row} gutter={32} mb={8}>
        <Box as={Col} xs={24}>
          <SelectDestino
            control={control}
            form={form}
            showCargo
            showPessoa
            tenantId={tenant.id}
            setValue={setValue}
            tiposPessoa={[TipoEntidadeEnum.Condomino]}
          />
        </Box>
      </Box>

      <Box as={Row} gutter={32} mb={8}>
        <Box as={Col} xs={24}>
          <Field
            label="Nome do desconto"
            control={control}
            name="nome"
            rules={{
              required: true,
            }}
          />
        </Box>
      </Box>

      <Title text="Quanto será o valor?" />

      <Box as={Row} gutter={32} mb={4}>
        <Box as={Col} xs={12}>
          <Field
            label="Forma de desconto"
            control={control}
            name="formaAplicacaoValorId"
            rules={{
              required: true,
            }}
            render={({ field, isInvalid }) => (
              <SelectBaseAntd
                size="large"
                onChange={(v) => {
                  field.onChange(v);
                  setValue("valor", undefined);
                }}
                isInvalid={isInvalid}
                value={field.value}
                options={getFormaDescontoOptions()}
                placeholder="Selecione a forma"
              />
            )}
          />
        </Box>

        <Box as={Col} xs={12} mb={3}>
          <Field
            label={
              form.formaAplicacaoValorId === FormaAplicacaoValorEnum.Porcentagem
                ? "Porcentagem(%)"
                : "Valor fixo (R$)"
            }
            control={control}
            name="valor"
            rules={{
              required: true,
            }}
            render={({ field, isInvalid }) => (
              <InputMoney
                isInvalid={isInvalid}
                {...field}
                maxValue={
                  form.formaAplicacaoValorId ===
                  FormaAplicacaoValorEnum.Porcentagem
                    ? 100
                    : undefined
                }
              />
            )}
          />
        </Box>
      </Box>
    </>
  );
}

const Title = ({ text }: { text: string }) => (
  <Text as="h3" fontSize={18} fontWeight="bold" mb={4}>
    {text}
  </Text>
);

export default FormGrupoDesconto;
